/**
 * caion_wage_common_data 컬럼명 = API·폼 필드명 (단일 소스)
 * 백엔드: nodejs_caion/constants/commonWageFields.js 와 동기화
 * DB 테이블·WHERE: nodejs_caion/constants/commonWageDbSchema.js
 *   - caion_member: m_status (m_ddate/m_isuse 없음)
 *   - caion_wage_common_data: cwhd_ddate, cwhd_isuse
 */

export const CWHD_SAVE_FIELDS = [
  'cwhd_pay_calc_hourly',
  'cwhd_work_days',
  'cwhd_work_hours',
  'cwhd_basic',
  'cwhd_basic_calc_mode',
  'cwhd_overtime_hours',
  'cwhd_overtime',
  'cwhd_overtime_nontax',
  'cwhd_night_hours',
  'cwhd_night',
  'cwhd_night_nontax',
  'cwhd_holiday_hours',
  'cwhd_holiday',
  'cwhd_holiday_nontax',
  'cwhd_dayoff',
  'cwhd_senior',
  'cwhd_sunim',
  'cwhd_bonus',
  'cwhd_bosu',
  'cwhd_bojon',
  'cwhd_other',
  'cwhd_dang',
  'cwhd_lunch',
  'cwhd_car',
  'cwhd_child',
  'cwhd_wage_total',
  'cwhd_taxable',
  'cwhd_usual',
  'cwhd_l_yeon',
  'cwhd_l_gun',
  'cwhd_l_jang',
  'cwhd_l_go',
  'cwhd_l_so',
  'cwhd_l_ji',
  'cwhd_l_jiwon',
  'cwhd_l_sik',
  'cwhd_l_etc',
  'cwhd_l_yearend',
  'cwhd_l_total',
  'cwhd_c_yeon',
  'cwhd_c_gun',
  'cwhd_c_jang',
  'cwhd_c_go',
  'cwhd_c_sil',
  'cwhd_c_san',
  'cwhd_c_out',
  'cwhd_c_total',
  'cwhd_manual',
  'cwhd_memo',
  'cwhd_production_nontax',
  'cwhd_lunch_expense',
  'cwhd_is_owner',
  'cwhd_manual_flags',
] as const;

export const CWHD_FORM_INPUT_FIELDS = [
  'cwhd_pay_calc_hourly',
  'cwhd_work_days',
  'cwhd_work_hours',
  'cwhd_overtime_hours',
  'cwhd_night_hours',
  'cwhd_holiday_hours',
  'cwhd_dayoff',
  'cwhd_senior',
  'cwhd_sunim',
  'cwhd_bonus',
  'cwhd_bosu',
  'cwhd_bojon',
  'cwhd_other',
  'cwhd_dang',
  'cwhd_lunch',
  'cwhd_car',
  'cwhd_child',
  'cwhd_memo',
] as const;

export const CWHD_DEDUCT_FIELDS = [
  'cwhd_l_yeon',
  'cwhd_l_gun',
  'cwhd_l_jang',
  'cwhd_l_go',
  'cwhd_l_so',
  'cwhd_l_ji',
  'cwhd_l_jiwon',
  'cwhd_l_sik',
  'cwhd_l_etc',
  'cwhd_l_yearend',
  'cwhd_c_sil',
  'cwhd_c_san',
  'cwhd_c_out',
] as const;

export type CcwdFormInputField = (typeof CWHD_FORM_INPUT_FIELDS)[number];
export type CcwdDeductField = (typeof CWHD_DEDUCT_FIELDS)[number];
export type CcwdSaveField = (typeof CWHD_SAVE_FIELDS)[number];

/** 요양시설 월별임금 — 근무시간 기본값(월) */
export const COMMON_WAGE_DEFAULT_WORK_HOURS = 209;

/** API 저장 요청 메타 (DB 컬럼명과 동일) */
export interface CommonWageSaveMeta {
  m_code: string;
  cwhd_name: string;
  cwhd_birth?: string | null;
  cwhd_ym: string;
  cwhd_biz_gubun?: string;
}
